export interface ThemeColors { primary: string; secondary: string; accent: string }
export const DEFAULT_THEME: ThemeColors = { primary: '#06b6d4', secondary: '#8b5cf6', accent: '#a855f7' };
export function parseThemeColors(raw: unknown): ThemeColors {
  const value = raw && typeof raw === 'object' ? raw as Record<string, unknown> : {};
  const color = (key: keyof ThemeColors) => typeof value[key] === 'string' && /^#[0-9a-f]{6}$/i.test(value[key] as string) ? value[key] as string : DEFAULT_THEME[key];
  return { primary: color('primary'), secondary: color('secondary'), accent: color('accent') };
}
export function applyThemeToDOM(colors: ThemeColors) {
  const root = document.documentElement;
  root.style.setProperty('--color-primary', colors.primary);
  root.style.setProperty('--color-secondary', colors.secondary);
  root.style.setProperty('--color-accent', colors.accent);
  root.style.setProperty('--color-ring', colors.primary);
}
